import { message } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

export const showProfileDroppedInFolderMessage = (count: number): void => {
  message.success(<Trans i18nKey='header.foldersBar.profilesDropped' count={count} />);
};
